import {Fragment} from "preact";
import {iconWarning} from "../../assets";
import { useAppContext } from "../../contexts";
import {useErrorBadge} from "./useErrorBadge";

/**
 * Generic error badge component that can be used throughout the whole application.
 *
 * Parameter `message` is required as it is the one responsible for controlling
 * the component's display state.
 * */
const ErrorBadge = props => {
    // Component logic data
    const componentProps = useErrorBadge(
        {...props},
        props?.mode
    );

    // Destructured component logic data
    const {
        message,
        centered,
        // rounded
    } = componentProps;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    // Prevents double rendering when there's a legacy calling
    if (props?.mode !== "new" && !props?.message) {
        return;
    }

    return message ? (
        <Fragment>
            <div
                className={`
                    p-3 gap-x-2 border-2 w-full h-full rounded-lg flex flex-row items-center 
                    ${(centered ? "justify-center" : "justify-start")} 
                    ${highContrast ? "grayBackground yellowBorder" : "bg-light-gray border-sabin-red-default"}
                `}
            >
                <img
                    src={iconWarning}
                    className={`select-none pointer-events-none ${highContrast ? "hue-rotate-60 brightness-200" : ""}`}
                    alt="Warning icon"
                />
                <p className={`font-bold ${highContrast ? "highTitleThird" : "text-[#212B36]"}`}>
                    {message}
                </p>
            </div>
        </Fragment>
    ) : null;
}

export default ErrorBadge;
